import { render, staticRenderFns } from "./automations.vue?vue&type=template&id=d59262ca&scoped=true"
import script from "./automations.vue?vue&type=script&lang=js"
export * from "./automations.vue?vue&type=script&lang=js"
import style0 from "./automations.vue?vue&type=style&index=0&id=d59262ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59262ca",
  null
  
)

export default component.exports